import { admin2 } from '@/api/instance'

//= > 新增設備項目
export const CreateResource = async ({
  shopId,
  enabled,
  name,
  image,
  order,
  enableTimeOff,
  bookingMax,
  appointmentServices,
  resourceItemCategoryIds,
  businessTimeBy,
  excludeTimeRules,
  businessTimeBranchId,
}) => {
  const res = await admin2({
    method: 'post',
    url: `/${shopId}/resourceItem`,
    data: {
      enabled,
      name,
      image,
      order,
      bookingMax,
      enableTimeOff,
      appointmentServices,
      resourceItemCategoryIds,
      businessTimeBy,
      excludeTimeRules,
      businessTimeBranchId,
    },
  })

  return res
}

//= > 更新設備項目
export const UpdateResource = async ({
  shopId,
  id,
  enabled,
  name,
  image,
  order,
  enableTimeOff,
  bookingMax,
  appointmentServices,
  resourceItemCategoryIds,
  businessTimeBy,
  excludeTimeRules,
  businessTimeBranchId,
}) => {
  const res = await admin2({
    method: 'put',
    url: `/${shopId}/resourceItem/${id}`,
    data: {
      enabled,
      name,
      image,
      order,
      bookingMax,
      enableTimeOff,
      appointmentServices,
      resourceItemCategoryIds,
      businessTimeBy,
      excludeTimeRules,
      businessTimeBranchId,
    },
  })
  return res
}

/**
 * 取得設備項目列表 admin.resourceItem.find
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=20] - 查詢筆數
 * @param {string} [params.name] - 設備名稱（模糊搜尋）
 * @param {string} [params.resourceItemCategoryIds] - 設備類別ID（逗號分隔）
 * @param {string} [params.resourceItemCategoryTagIds] - 設備類別群組ID（逗號分隔）
 * @param {string} [params.businessTimeBranchId] - 營業時間的分店ID
 * @returns {Promise<Array>} 設備項目列表
 */
export const GetResourceItem = async ({
  shopId,
  start,
  limit,
  name,
  resourceItemCategoryIds,
  resourceItemCategoryTagIds,
  businessTimeBranchId,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/resourceItem`,
    params: {
      start,
      limit,
      name,
      resourceItemCategoryIds,
      resourceItemCategoryTagIds,
      businessTimeBranchId,
    },
  })

  return res
}

/**
 * 取得設備項目數量 admin.resourceItem.count
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} [params.name] - 設備名稱（模糊搜尋）
 * @param {string} [params.resourceItemCategoryIds] - 設備類別ID（逗號分隔）
 * @param {string} [params.resourceItemCategoryTagIds] - 設備類別群組ID（逗號分隔）
 * @param {string} [params.enabled] - 是否啟用
 * @returns {Promise<Object>} 設備項目數量
 */
export const GetResourceItemCount = async ({
  shopId,
  name,
  resourceItemCategoryIds,
  resourceItemCategoryTagIds,
  enabled,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/resourceItem/count`,
    params: {
      name,
      resourceItemCategoryIds,
      resourceItemCategoryTagIds,
      enabled,
    },
  })

  return res
}

//= > 取得設備項目
export const FindResourceItem = async ({
  shopId,
  id,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/resourceItem/${id}`,
  })
  return res
}

//= > 刪除設備項目
export const DeleteResourceItem = async ({
  shopId,
  id,
}) => {
  const res = await admin2({
    method: 'delete',
    url: `/${shopId}/resourceItem/${id}`,
  })
  return res
}

//= > 取得設備模組設定
export const GetResourceConfig = async ({
  shopId,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/resourceConfig`,
  })
  return res
}

//= > 更新設備模組設定
export const UpdateResourceConfig = async ({
  shopId,
  assignRule,
  pageText,
  clientSkipSelect,
}) => {
  const res = await admin2({
    method: 'put',
    url: `/${shopId}/resourceConfig`,
    data: {
      assignRule,
      pageText,
      clientSkipSelect,
    },
  })
  return res
}

//= > 查詢設備項目的預約空檔時段
export const GetPeriods = async ({
  shopId,
  id,
  start,
  end,
}) => {
  const res = await admin2({
    method: 'get',
    url: `${shopId}/resourceItem/${id}/schedule`,
    params: {
      start,
      end,
    },
  })

  return res
}

//= > 更新設備項目關閉時段
export const UpdatePeriods = async ({
  shopId,
  id,
  operates,
}) => {
  const res = await admin2({
    method: 'put',
    url: `${shopId}/resourceItem/${id}/scheduleBan`,
    data: {
      operates,
    },
  })

  return res
}

//= > 查詢設備項目的預約空檔時段

export const GetMoreSchedule = async ({
  shopId,
  resourceItemIds,
  start,
  end,
}) => {
  const res = await admin2({
    method: 'post',
    url: `${shopId}/resourceItem/moreSchedule`,
    data: {
      resourceItemIds,
      start,
      end,
    },
  })

  return res
}

//= > 取得設備項目ID清單
export const GetResourceItemIds = async ({
  shopId,
  enabled,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/resourceItem/ids`,
    params: {
      enabled,
    },
  })

  return res
}

//= > 批次更新設備項目
export const BatchUpdateResourceItem = async ({
  shopId,
  ids,
  enabled,
}) => {
  const res = await admin2({
    method: 'put',
    url: `/${shopId}/resourceItem/batchUpdate`,
    data: {
      ids,
      enabled,
    },
  })

  return res
}

//= > 取得排班規則藉由門市
export const GetScheduleRuleByBranch = async ({
  shopId,
  branchId,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/resourceItem/getScheduleRuleByBranch`,
    params: {
      branchId,
    },
  })
  return res
}

//= > 取得排班規則藉由設備項目
export const GetScheduleRuleByResourceItem = async ({
  shopId,
  resourceItemId,
}) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/resourceItem/getScheduleRuleByResourceItem`,
    params: {
      resourceItemId,
    },
  })
  return res
}
